const PARAMETER_DESCRIPTIONS: Record<string, string> = {
  ['speaker_labels']: 'Enables speaker diarization so each utterance is assigned to a speaker.',
  ['speaker_options']:
    'Sets positive integer minimum and maximum speaker bounds. Speaker labels must be enabled and min cannot exceed max.',
  ['speakers_expected']:
    'Sets an exact positive integer speaker count from 1 to 10. Speaker labels must be enabled; cannot be combined with speaker_options.',
  multichannel: 'Transcribes each audio channel separately when speakers are recorded on different channels.',
  ['language_code']: 'Specifies one of the language codes supported by AssemblyAI.',
  ['speech_model']:
    'Selects universal-3-5-pro or universal-2. AssemblyAI has deprecated this field in favor of speech_models.',
  ['speech_models']: 'Lists universal-3-5-pro and/or universal-2 in priority order. The enabled array cannot be empty.',
  ['keyterms_prompt']:
    'Improves recognition of domain-specific terms. Each phrase can contain up to 6 words; global defaults allow 200 total words for Universal-2 compatibility.',
  disfluencies: 'Includes filler words such as “um” and “uh” in the transcript when the model supports it.',
  ['custom_spelling']:
    'Maps a non-empty from array to one replacement word. Each source phrase can contain up to 5 words.',
};

export const getParameterDescription = (parameter: string) =>
  PARAMETER_DESCRIPTIONS[parameter] ?? 'No AssemblyAI description is registered for this parameter.';
